import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import ManageEventsSidebarItem from './ManageEventsSidebarItem/ManageEventsSidebarItem';
import { FIELDS, POSTER_FIELDS } from '../../../constants/eventForm';
import Style from '../../../styles/common';

const Container = styled('div')`
  background-color: ${Style.color.MANAGE_SIDEBAR};
  border-right: 2px solid ${Style.color.listDivider};
  max-width: ${Style.MEASUREMENT.MANAGE_EVENTS_SIDEBAR.MAX_WIDTH};
  min-width: ${Style.MEASUREMENT.MANAGE_EVENTS_SIDEBAR.MIN_WIDTH};
  width: 30%;
`;

function ManageEventsSidebar(props) {
  return (
    <Container>
      {getItems()}
    </Container>
  );

  function getItems() {
  return props.events.map((event, index) => {
    const eventId = event.id;
    const isActive = props.activeEventId ? eventId === props.activeEventId : index === 0;
    return (
      <ManageEventsSidebarItem
        eventId={eventId}
        key={eventId}
        isActive={isActive}
        isLast={index === props.events.length - 1}
        onClick={props.onClick}
        posterUrl={event[FIELDS.POSTER][POSTER_FIELDS.URL]}
        title={event.title}
      />
    );
  });
}

}

ManageEventsSidebar.propTypes = {
  activeEventId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  events: PropTypes.arrayOf(PropTypes.object),
};
ManageEventsSidebar.defaultProps = {
  activeEventId: '',
  events: [],
};

export default ManageEventsSidebar;



// WEBPACK FOOTER //
// ./src/views/ManageEvents/ManageEventsSidebar/ManageEventsSidebar.js